import React from 'react';
import { Provider } from 'react-redux';
import JourneyReportCard from './index';
import journeyBuilderStore from '../../stores/journeyBuilderStore';

export default props => (
  <Provider store={journeyBuilderStore(props)}>
    <JourneyReportCard {...props} />
  </Provider>
);
